import { MenuItem } from '@szhsin/react-menu';
import styled from 'styled-components';

import { Button, Clickable, Text } from '@catalyze/ui';
import { edmStatusColor } from 'utils/edmStatusColor';

export const EditButton = styled(Clickable)`
    & > svg {
        width: 1.5rem;
    }
`;

export const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 700;
    margin-bottom: 1.5rem;
`;

export const Name = styled(Text)`
    font-weight: 700;
    font-size: ${({ theme }) => theme.fontSizes[5]};
`;

export const Relationship = styled(Text)`
    color: #4faebc;
    font-weight: 700;
    font-size: ${({ theme }) => theme.fontSizes[4]};
`;

export const MenuButton = styled(Button)`
    font-weight: normal;

    & > svg {
        width: 0.375rem;
        fill: ${({ theme }) => theme.colors.formLabel};
    }
`;

export const StatusColor = styled.div`
    width: 0.625rem;
    height: 0.625rem;
    border-radius: 50%;
    background-color: ${edmStatusColor};
`;

export const StyledMenuItem = styled(MenuItem)`
    font-weight: normal;
    display: flex;
    align-items: center;
    margin: 0.625rem 0;

    & > ${StatusColor} {
        margin-right: 1rem;
    }
`;
